<app-kpi-widget 
  [title]="'driverDashboard.widgets.driversInYard' | transloco"
  [isLoading]="isLoading"
  [icon]="'ph-warehouse'"
  [totalValue]="value"
  [valueFormatter]="formatValue"
  [hasError]="hasError"
  [errorMessage]="errorMessage"
  (clicked)="openDriverInYardModal()"
  [widgetDisabled]="false"
  [dropdownEnabled]="false"
  [isImageIcon]="false"
  [hasFooter]="false"
  [percentageDifferenceEnabled]="false"
  [hasValueOnly]="true">
</app-kpi-widget>